import { useMemo } from 'react';
import { Filter } from '../DataTable';
import { NumericFilter } from '../HeaderFilter';
import { DateRangeFilter } from '../HeaderFilter/DateRangeFilter';
import { SelectFilter } from '../HeaderFilter/SelectFilter';
import { SelectMultipleFilter } from '../HeaderFilter/SelectMultipleFilter';
import { TextFilter } from '../HeaderFilter/TextFilter';

interface Props {
    filters: Filter[];
    enabledFilters?: string[];
    // true = Filterzeilen füllen die volle Breite (Formular-Kontext); false = kompaktes Popover (DataTable-Header)
    fullWidth?: boolean;
}

const FilterRenderer = ({ filters, enabledFilters, fullWidth = false }: Props) => {
    // Baut die Filterzeilen anhand ihres Typs; die Steuerelemente bleiben kompakt, nur die Zeilenbreite variiert.
    const renderFilter = useMemo(() => {
        return filters?.map((filter) => {
            if (typeof enabledFilters === 'object' ? enabledFilters.includes(filter.filterKey) : true) {
                const { filterKey, filterType } = filter;

                switch (filterType) {
                    case 'numeric':
                        return <NumericFilter key={filterKey} {...filter} fullWidth={fullWidth} />;

                    case 'text':
                        return <TextFilter key={filterKey} {...filter} fullWidth={fullWidth} />;

                    case 'date':
                        return <DateRangeFilter key={filterKey} {...filter} fullWidth={fullWidth} />;

                    case 'datetime':
                        return <DateRangeFilter key={filterKey} datetime {...filter} fullWidth={fullWidth} />;

                    case 'select':
                        return <SelectFilter key={filterKey} {...filter} fullWidth={fullWidth} />;

                    case 'select-multiple':
                        return <SelectMultipleFilter key={filterKey} {...filter} fullWidth={fullWidth} />;

                    default:
                        return null;
                }
            }
        });
    }, [enabledFilters, filters, fullWidth]);

    if (
        filters?.filter((filter) =>
            typeof enabledFilters === 'object' ? enabledFilters.includes(filter.filterKey) : true
        ).length <= 0
    )
        return null;
    return (
        <div
            className={
                'tw-flex tw-min-h-min tw-w-full tw-flex-col tw-gap-2 tw-overflow-y-auto ' +
                // Im Formular-Modus mehr Höhe und expliziter horizontaler Cutoff (verhindert den ungewollten X-Scrollbalken).
                (fullWidth ? 'tw-max-h-[60vh] tw-overflow-x-hidden' : 'tw-max-h-[200px]')
            }
        >
            {renderFilter}
        </div>
    );
};

export default FilterRenderer;
